export default __webpack_public_path__ + "static/media/email.a8a029d7.svg";